import { Box, Stack, Text, styled } from '@ltvco/refresh-lib/theme';

import { CLASS_ACTION_REPORT_SECTION_IDS } from '../shared/constants';
import { DesktopReportSection } from '../shared/DesktopReportSection';
import { BodyParagraph, BulletList } from '../shared/reportTypography';

import type { DocketDetailStatusSection } from '../types';

const TimingCallout = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  backgroundColor:
    theme.palette.mode === 'light'
      ? theme.palette.grey[50]
      : theme.palette.grey[900],
  marginTop: theme.spacing(2),
}));

export function StatusSection({
  status,
}: {
  status: DocketDetailStatusSection;
}) {
  const narrative = status.narrative?.trim() ?? '';
  const focalTimingText = status.focal_timing_text?.trim() ?? '';
  const courtExpectationBullets = (status.court_expectation_bullets ?? [])
    .map((b) => b.trim())
    .filter(Boolean);

  const hasContent =
    narrative || courtExpectationBullets.length || focalTimingText;

  if (!hasContent) {
    return null;
  }

  return (
    <DesktopReportSection
      title="Status"
      sectionId={CLASS_ACTION_REPORT_SECTION_IDS.status}
    >
      <Stack spacing={1.5}>
        {narrative ? <BodyParagraph>{narrative}</BodyParagraph> : null}
        {courtExpectationBullets.length ? (
          <BulletList component="ul" sx={{ listStyle: 'disc' }}>
            {courtExpectationBullets.map((bullet, index) => (
              <Text component="li" key={`${index}-${bullet}`}>
                {bullet}
              </Text>
            ))}
          </BulletList>
        ) : null}
        {focalTimingText ? (
          <TimingCallout>
            <Text sx={{ fontSize: 15, fontWeight: 600, mb: 0.5 }}>Timing</Text>
            <BodyParagraph sx={{ fontSize: 15 }}>
              {focalTimingText}
            </BodyParagraph>
          </TimingCallout>
        ) : null}
      </Stack>
    </DesktopReportSection>
  );
}
